import axios from "axios";

export default class ApiResource {

    constructor() {
        this.baseuri = window.appVars.apiUrl;
        this.axios = axios;
        this.axios.defaults.headers.common = {
            'X-CSRF-TOKEN'    : window.appVars.csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
        };
        this.axios.interceptors.response.use(response => {
            return response;
        }, error => {
            this.interceptErrors(error);
        });
    }

    get(uri) {
        return this.axios.get(this.baseuri + uri);
    }

    post(uri, data) {
        return this.axios.post(this.baseuri + uri, data);
    }

    put(uri, data) {
        return this.axios.put(this.baseuri + uri, data);
    }

    patch(uri, data) {
        return this.axios.patch(this.baseuri + uri, data);
    }

    delete(uri) {
        return this.axios.delete(this.baseuri + uri);
    }

    interceptErrors(error) {
        this.catch(error);
    }

    catch(errors) {

        if(errors.response.status === 401 || errors.response.status === 404) {
            return;
        }

        // let data = errors.response.data;
        // let content = '';
        // if(typeof data === 'string') {
        //     content = data;
        // }
        // else {
        //     content = this.dump(data);
        // }
        //
        // document.body.innerHTML = content;
    }

    // dump(data) {
    //     let content = '';
    //     for(let property in data) {
    //         if(typeof data[property] === 'object') {
    //             content += '<b>' + property + '</b>' + ': ' + this.dump(data[property]) + '<br>';
    //         }
    //         else {
    //             content += '<b>' + property + '</b>' + ': ' + data[property] + '<br>';
    //         }
    //     }
    //     return content;
    // }
}
